export default function Description({ product: { description, customFields }}: { product: BigCommerceProduct }): JSX.Element {
	return (
		<div className="flex flex-col-reverse sm:block">
			<style jsx global>{`
				.product-description * {
					@apply max-w-full;
				}

				.product-description p:not(:first-child), .product-description ul:not(:first-child) {
					@apply mt-1;
				}

				.product-description p+p:not(:first-child) {
					@apply mt-4;
				}
			
				.product-description h4:not(:first-child) {
					@apply mt-8;
				}
			
				.product-description h4 {
					@apply font-semibold text-2xl;
				}
			
				.product-description h4+p:not(:first-child) {
					@apply pl-4;
				}
			
				.product-description ul {
					@apply list-disc pl-8;
				}
			`}</style>

			{ customFields.length > 0 && (
				<div className="bg-gray-150 mt-4 rounded-lg text-sm divide-y divide-gray-500 px-3 sm:mt-0 sm:ml-6 sm:float-right md:ml-12">
					{ customFields.map(field => (
						<p className="py-2" key={field.name}><span className="font-extrabold">{field.name}:</span> {field.value}</p>
					))}
				</div>
			)}

			<div className="product-description" dangerouslySetInnerHTML={{ __html: description }} />
		</div>
	)
}
